import * as fromDatatype from "../datatype-library/index";

export interface bl_ppl_ap_testbed_sending_doc_hdr_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	sending_test_name: fromDatatype.VarcharDatatypeInterface;
	xml: fromDatatype.TextDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	property_json: any;
	namespace: fromDatatype.VarcharDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	created_by_name: fromDatatype.VarcharDatatypeInterface;
	updated_by_name: fromDatatype.VarcharDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_ppl_ap_testbed_sending_doc_hdr_RowClass
	implements bl_ppl_ap_testbed_sending_doc_hdr_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	sending_test_name: fromDatatype.VarcharDatatypeInterface;
	xml: fromDatatype.TextDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	property_json: any;
	namespace: fromDatatype.VarcharDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	created_by_name: fromDatatype.VarcharDatatypeInterface;
	updated_by_name: fromDatatype.VarcharDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}
